import Vue from 'vue'
import App from './App.vue'
import vant from 'vant'
import { router } from './router/router'
import moment from "moment"; //时间格式转换
import 'vant/lib/index.css'
// Vue.forceUpdate();
//Alloyfinger手势插件
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'

Vue.use(AlloyFingerPlugin, {
  AlloyFinger
})

Vue.config.productionTip = false
Vue.prototype.moment = moment;
Vue.use(vant)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
